import RequestStatus from '../store/schema/RequestStatus';
import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import { ReplyWithAttachmentSuggestion } from 'owa-mail-store';

export const setStoreStatus = mutatorAction(
    'SET_SMART_DOC_SUGGESTION_STATUS',
    (status: RequestStatus) => {
        getStore().status = status;
    }
);

export const setSuggestions = mutatorAction(
    'SET_SMART_DOC_SUGGESTIONS',
    (suggestions: ReplyWithAttachmentSuggestion[], status: RequestStatus) => {
        getStore().suggestions = suggestions;
        getStore().status = status;
    }
);
